import React, { useEffect, useRef } from "react";

import "./ScrollDownComponent.css";

export function ScrollDown() {
  const elRef = useRef(null);

  const scrollDistance = 320;

  // TODO: Replace this logic with scroll driven animation when it becomes vastly adopted
  useEffect(() => {
    const handleScroll = () => {
      const clamped = Math.min(Math.max(window.scrollY, 0), scrollDistance);
      const opacity = 100 - (clamped / scrollDistance) * 100;

      elRef.current.style.setProperty("--scroll-opacity", `${opacity}%`);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // initialize on mount

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div ref={elRef} className="scroll-down position-relative">
      <div className="scroll-down-content">
        <div>Scroll to view all releases</div>
        <span className="mouse"></span>
      </div>
    </div>
  );
}
